import React from 'react';
import './Template.scss';
import Button from '../../../Shared/Button/Button';
import If from '../../../Shared/If/If';

const Template = ({
  header,
  nextButton,
  backButton,
  onNextClick,
  onBackClick,
  children,
}) => {
  return (
    <div className="bank-status-failure">
      <div className="template-failure-modal">
        <div className="template-failure-heading e2e-failure-msg-header">
          {header}
        </div>
        <div className="template-message-container e2e-eVerify-try-again-button">
          <div className="template-failure-msg">{children}</div>
          <div className="template-button-list">
            <If test={nextButton}>
              <Button
                contextStyle={{
                  display: 'block',
                  borderRadius: '2px',
                  height: '40px',
                  fontSize: '16px',
                  fontWeight: 700,
                  padding: '16px',
                  minWidth: 'unset',
                  textAlign: 'center',
                  margin: 'auto',
                }}
                buttonType="primary"
                onClick={onNextClick}
              >
                {nextButton}
              </Button>
            </If>
            <If test={backButton}>
              <div className="template-back-btn" onClick={onBackClick}>
                {backButton}
              </div>
            </If>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Template;
